import { IncomingMessage } from 'http'
import { useQuery, QueryObserverResult } from 'react-query'

import { createClient } from '@services/api'

export interface AffiliateInfo {
  name: string
  slug?: string
  price: {
    offered: string
    regular: string
    discount: string
  }
  logo?: string
  image?: string
  url?: string
}

export function fetchAffiliateInfo(req?: IncomingMessage) {
  return async ({ queryKey }) => {
    const [, affiliate] = queryKey
    const { data } = await createClient(req).get(
      `/partners/public/${affiliate}`
    )

    return data as AffiliateInfo
  }
}

export function useAffiliateInfo(
  affiliate: string
): QueryObserverResult<AffiliateInfo> {
  return useQuery(['affiliate', affiliate], fetchAffiliateInfo())
}
